import {Nullable} from "../definitions/types";
import jwt_decode, {JwtPayload} from "jwt-decode";
import {IClaims} from "../definitions/interfaces";
import {AudienceType} from "../definitions/enums";

const tokenKey = "token";

class JwtTokenHandler {
    get = (): Nullable<string> => localStorage.getItem(tokenKey);

    set = (token: string) => localStorage.setItem(tokenKey, token);

    remove = () => localStorage.removeItem(tokenKey);

    decode = () => {
        // Attempt to get the token from local storage
        const token = this.get();

        // If the token exists, decode it
        if (token) return jwt_decode<IClaims>(token);

        // If the token does not exist, return default claims
        return {aud: AudienceType.Unknown};
    }
}

export default new JwtTokenHandler();